import React from "react";
import "./Footer.scss";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__copy">
        <p>&copy; 2024 Mnema. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;